<template>
  <div id="refactor-news">
    <header-menu></header-menu>
    <div class="header-news-banner">
      <div class="banner-news-content">
        <h1 class="banner-news-title">{{ bannerData.title || '公司动态' }}</h1>
        <p class="banner-news-description">{{ bannerData.summary || '聚焦团队发展、业务突破与荣誉时刻，见证灰鲸活力' }}</p>
      </div>
    </div>
    <!-- 新增tab切换区域 -->
    <div class="tab-container">
      <div class="tab-wrapper">
        <div
            class="tab-item"
            :class="{ active: infoType === '0' }"
            @click="switchTab('0')"
        >
          公司动态
        </div>
        <div
            class="tab-item"
            :class="{ active: infoType === '1' }"
            @click="switchTab('1')"
        >
          行业资讯
        </div>
        <div
            class="tab-item"
            :class="{ active: infoType === '2' }"
            @click="switchTab('2')"
        >
          变现指南
        </div>
      </div>
    </div>
    <!-- 新增内容区域 -->
    <div class="content-container">
      <!-- 上部分 -->
      <div class="top-section" v-for="(item) in industryList.rowData.rows" @click="goToDetails(item.infoId)">
        <div class="top-content">
          <div class="news-image">
            <img :src="item.coverImage || 'https://cdn.huimiaokeji.com/bj_kh@2x.png'" alt="新闻图片">
          </div>
          <div class="news-info">
            <h3 class="news-title">{{ item.title || '暂无标题' }}</h3>
            <p class="news-description">{{ item.summary || '暂无描述' }}</p>
            <div class="news-meta">
              <span class="news-type">{{ getInfoTypeName(infoType) }}</span>
              <span class="news-time">{{ formatDate(item.publishTime) }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页组件 -->
      <div class="pagination-container" v-if="total > pageSize">
        <div class="pagination">
          <button
              class="page-btn"
              :disabled="currentPage === 1"
              @click="prevPage"
          >
            上一页
          </button>
          <span class="page-info">
            {{ currentPage }} / {{ totalPages }}
          </span>
          <button
              class="page-btn"
              :disabled="currentPage === totalPages"
              @click="nextPage"
          >
            下一页
          </button>
        </div>
      </div>

      <!-- 中间部分 - 推荐文章 -->
      <div class="middle-section">
        <h2 class="section-title">
          <span class="title-bar"></span>
          推荐阅读
        </h2>
        <div class="article-list">
          <div
              class="article-item"
              v-for="(item, index) in industryList.recData"
              :key="'rec-' + index"
              @click="goToDetails(item.infoId)"
          >
            {{ item.title || '暂无标题' }}
          </div>
        </div>
      </div>

      <!-- 下部分 - 热门文章 -->
      <div class="bottom-section">
        <h2 class="section-title">
          <span class="title-bar"></span>
          热门文章
        </h2>
        <div class="article-list">
          <div
              class="article-hot-item"
              v-for="(item, index) in industryList.hotData"
              :key="'hot-' + index"
              :data-index="index + 1"
              @click="goToDetails(item.infoId)"
          >
          {{ item.title || '暂无标题' }}
        </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <floating-modal ref="floatingModal"></floating-modal>
  </div>
</template>

<script>
import {getIndustryInfo, qryBannerInfo} from '../../api/index.js';
import FooterMenu from '../../components/footer-menu.vue';
import HeaderMenu from "../../components/header-menu.vue";
import FloatingModal from "~/components/floating-modal.vue";
import { aes } from '../../utils/crypto.js';

export default {
  name: 'refactor-news',
  components: {
    FloatingModal,
    HeaderMenu,
    FooterMenu
  },
  data() {
    return {
      industryList: {
        recData: [],
        hotData: [],
        rowData: {
          rows: [],
          total: 0
        }
      },
      bannerData: {
        title: '',
        summary: '',
      },
      queryParams: {
        pageNum: 1,
        pageSize: 100,
      },
      infoType: "0", //0公司动态、1行业资讯、2变现指南
      total: 0, // 总数据条数
      currentPage: 1, // 当前页码
      pageSize: 10 // 每页条数
    }
  },
  computed: {
    // 计算总页数
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  created() {
    qryBannerInfo('公司动态Banner').then((res) => {
      if (res.code == 200) {
        this.bannerData = res.data || {}
      }
    });
    document.title = '灰鲸网络-灰鲸资讯';
    this.queryIndustryInfo();
  },
  methods: {
    switchTab(tab) {
      this.infoType = tab;
      this.queryIndustryInfo();
    },
    goToDetails(infoId) {
      const encrypted = aes.encrypt(infoId+':'+this.infoType);
      const url = `https://www.huimiaokeji.com/refactorDetails?infoId=${encodeURIComponent(encrypted)}`;
      window.open(url, '_blank');
    },
    async queryIndustryInfo() {
      let res = await getIndustryInfo({
        infoType: this.infoType,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      });
      if (res.code == 200) {
        this.industryList = res.data || {};
        this.total = res.data.rowData.total || 0;
      }
    },
    // 获取资讯类型名称
    getInfoTypeName(type) {
      const typeMap = {
        '0': '公司动态',
        '1': '行业资讯',
        '2': '变现指南'
      };
      return typeMap[type] || '其他';
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return date.substring(0, 10);
    },
    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.queryIndustryInfo();
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.queryIndustryInfo();
      }
    }
  }
}
</script>

<style lang="less">
#refactor-news {
  background-color: #F3F7FF;
  .header-news-banner {
    margin-top: 80px;
    height: 240px;
    background: url(https://cdn.huimiaokeji.com/bj_hj2x.png) no-repeat;
    background-size: 100% 240px;
    width: 100%;
    display: flex;
    //align-items: center;
    //justify-content: center;
  }

  .banner-news-content {
    width: 820px;
    //text-align: center;
    margin-left: 120px;
  }

  .banner-news-title {
    font-size: 34px;
    margin-top: 70px;
    color: #0B00B5;
    margin-bottom: 16px;
    font-weight: bold;
    //text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .banner-news-description {
    font-size: 18px;
    font-weight: 400;
    color: #051940;
    margin-bottom: 40px;
    //text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
  /* 新增tab样式 */
  .tab-container {
    width: 100%;
    height: 80px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .tab-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tab-item {
    font-size: 20px;
    color: #666;
    cursor: pointer;
    padding: 8px 16px;
    margin: 0 50px; // 通过margin实现100px的间隔
    transition: all 0.3s ease;
  }

  .tab-item:hover {
    color: #0B00B5;
  }

  .tab-item.active {
    color: #0B00B5;
    font-weight: bold;
    position: relative;
  }

  .tab-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 3px;
    background-color: #0B00B5;
    border-radius: 3px;
  }

  /* 新增内容区域样式 */
  .content-container {
    margin: 28px 240px;
    display: flex;
    flex-direction: column;
    gap: 28px;
    /* 手机端响应式布局 */
    @media (max-width: 980px) {
      margin: 28px 100px;
    }
  }

  /* 上部分样式 */
  .top-section {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .top-content {
    display: flex;
    gap: 20px;
    cursor: pointer;
  }

  .news-image {
    width: 260px;
    height: 145px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .news-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .news-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .news-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin: 0 0 8px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .news-description {
    font-size: 14px;
    color: #666;
    margin: 0 0 8px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .news-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .news-type {
    font-size: 12px;
    color: #0B00B5;
    padding: 2px 8px;
    background-color: #F0F3FF;
    border-radius: 4px;
  }

  .news-time {
    font-size: 12px;
    color: #999;
  }

  /* 中间和下部分通用样式 */
  .middle-section,
  .bottom-section {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .section-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .title-bar {
    width: 10px;
    height: 24px;
    background: #0B00B5;
    border-radius: 5px;
  }

  .article-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .article-item {
    font-size: 14px;
    color: #333;
    padding: 12px;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // 新增样式：在前方添加8x8的灰色方块
    position: relative;
    padding-left: 32px; // 增加左内边距以容纳方块和间距
  }

  .article-item::before {
    content: '';
    position: absolute;
    left: 12px; // 与左侧保持原有的12px间距
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background: #D8D8D8;
  }

  .article-item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-image: linear-gradient(to right, #ddd 50%, transparent 50%);
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }

  .article-hot-item {
    font-size: 14px;
    color: #333;
    padding: 12px;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // 新增样式：在前方添加8x8的灰色方块
    position: relative;
    padding-left: 32px; // 增加左内边距以容纳方块和间距
  }

  .article-hot-item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-image: linear-gradient(to right, #ddd 50%, transparent 50%);
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }

  .article-hot-item::before {
    content: attr(data-index); // 使用data-index属性值作为内容
    position: absolute;
    left: 12px; // 与左侧保持原有的12px间距
    top: 51%;
    transform: translateY(-50%);
    width: 13px; // 增加宽度以容纳数字
    height: 13px; // 增加高度以容纳数字
    color: #0B00B5;
    font-weight: bold;
    font-size: 13px; // 适当的字体大小
    text-align: center; // 文字居中
    line-height: 13px; // 行高等于高度，垂直居中
    border-radius: 2px; // 轻微圆角
  }

  .article-hot-item:hover {
    background-color: #F8F9FF;
    color: #0B00B5;
  }

  .article-item:hover {
    background-color: #F8F9FF;
    color: #0B00B5;
  }

  /* 分页样式 */
  .pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .pagination {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .page-btn {
    padding: 8px 16px;
    background-color: #0B00B5;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .page-btn:hover:not(:disabled) {
    background-color: #1a00ff;
  }

  .page-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .page-info {
    font-size: 14px;
    color: #666;
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/refactor/News.vue